import { render, staticRenderFns } from "./DistributorResellers.vue?vue&type=template&id=165eb802"
import script from "./DistributorResellers.vue?vue&type=script&lang=js"
export * from "./DistributorResellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports